var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-wrap tag-wrapper"},_vm._l((_vm.extraValue),function(e,i){return _c('div',{staticClass:"tag"},[_c('small',[_vm._v(_vm._s(e.short_name))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }